export default __webpack_public_path__ + "static/media/operatory_2.267fd50c.png";